// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Nav from "../../resources/navigation/Nav.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PageBottomActionsBar from "../../resources/layout-and-structure/PageBottomActionsBar.res.js";
import * as PromotionEditDiscountedProductTable from "./PromotionEditDiscountedProductTable.res.js";
import * as PromotionEditDiscountedProductReducer from "./PromotionEditDiscountedProductReducer.res.js";
import * as PromotionEditDiscountedProductPickerModalTable from "./PromotionEditDiscountedProductPickerModalTable.res.js";

function PromotionEditDiscountedProductTableCard(props) {
  let onRequestProductsUpdate = props.onRequestProductsUpdate;
  let selectedPriceName = props.selectedPriceName;
  let products = props.products;
  let editable = props.editable;
  let match = Nav.Context.use();
  let match$1 = React.useReducer(PromotionEditDiscountedProductReducer.make, products);
  let dispatch = match$1[1];
  let rows = match$1[0];
  let match$2 = React.useState(() => false);
  let setPickerOpened = match$2[1];
  ReactUpdateEffect.use2(() => {
    dispatch({
      TAG: "Reset",
      _0: products
    });
  }, [
    products,
    selectedPriceName
  ]);
  ReactUpdateEffect.use1(() => {
    onRequestProductsUpdate(rows);
  }, [rows]);
  let onPickProducts = React.useCallback(newProducts => dispatch({
    TAG: "ProductsAdded",
    _0: newProducts
  }), []);
  let onRequestClose = React.useCallback(() => setPickerOpened(param => false), []);
  let renderActionsStart = () => {
    if (editable) {
      return JsxRuntime.jsx(Button.make, {
        label: I18n.t("Search product"),
        variant: {
          NAME: "ghost",
          VAL: {
            bordered: true
          }
        },
        tone: "brand",
        icon: "search",
        onPress: () => setPickerOpened(param => true)
      });
    } else {
      return null;
    }
  };
  let columns = React.useMemo(() => PromotionEditDiscountedProductTable.tableColumns(editable, selectedPriceName, products.length > 1, dispatch), [
    editable,
    selectedPriceName,
    products.length
  ]);
  let disabledIds = rows.map(param => param.cku);
  let rowsErrors = Stdlib_Array.filterMap(rows, row => {
    if (row.retailPrices === undefined) {
      return {
        key: row.cku,
        message: I18n.t("This product is not compatible with the selected price list.")
      };
    } else if (row.discount.amount === 0) {
      return {
        key: row.cku,
        message: I18n.t("The discount of this product must have a positive amount.")
      };
    } else {
      return;
    }
  });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(Card.make, {
        children: [
          editable ? JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx(Inline.make, {
                children: JsxRuntime.jsx(Button.make, {
                  label: I18n.t("Search product"),
                  variant: {
                    NAME: "ghost",
                    VAL: {
                      bordered: true
                    }
                  },
                  tone: "brand",
                  icon: "search",
                  onPress: () => setPickerOpened(param => true)
                })
              }),
              spaceX: "large"
            }) : null,
          JsxRuntime.jsx(PromotionEditDiscountedProductTable.make, {
            data: {
              TAG: "Done",
              _0: {
                TAG: "Ok",
                _0: rows
              }
            },
            columns: columns,
            keyExtractor: PromotionEditDiscountedProductTable.Row.keyExtractor,
            erroredRowsMap: rowsErrors,
            hideCard: true,
            maxHeight: 500,
            placeholderEmptyState: JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx(Inline.make, {
                children: JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("Please add products to create your promotional campaign."),
                  align: "center",
                  variation: "normal",
                  size: "small"
                }),
                align: "center"
              }),
              spaceX: "large",
              spaceY: "xlarge",
              style: {
                backgroundColor: "#f8f8fb"
              }
            })
          }),
          JsxRuntime.jsx(Box.make, {})
        ],
        variation: "unset"
      }),
      JsxRuntime.jsx(PromotionEditDiscountedProductPickerModalTable.make, {
        opened: match$2[0],
        selectedPriceName: selectedPriceName,
        disabledIds: disabledIds,
        onCommit: onPickProducts,
        onRequestClose: onRequestClose
      }),
      JsxRuntime.jsx(PageBottomActionsBar.make, {
        displayThreshold: 160,
        renderStart: renderActionsStart,
        renderEnd: props.renderPageActions,
        navOpened: match[0].opened
      })
    ]
  });
}

let make = React.memo(PromotionEditDiscountedProductTableCard, (oldProps, newProps) => {
  if (oldProps.products === newProps.products && oldProps.selectedPriceName === newProps.selectedPriceName) {
    return oldProps.editable === newProps.editable;
  } else {
    return false;
  }
});

let Reducer;

let PromotionTable;

export {
  Reducer,
  PromotionTable,
  make,
}
/* make Not a pure module */
